import { createAsyncThunk } from '@reduxjs/toolkit'
import PaymentMethod from './payment-method-model'
import {
  delete_paymentMethod,
  load_paymentMethods,
  store_paymentMethod,
} from './paymentMethod-service'

export const LoadPaymentMethodsAsync = createAsyncThunk<any, any>(
  'composer/load/paymentMethod',
  async (params: { uid: string }) => {
    return await load_paymentMethods(params)
  },
)

export const CreatePaymentMethodAsync = createAsyncThunk<any, any>(
  'composer/create/paymentMethod',
  async (params: PaymentMethod) => {
    return await store_paymentMethod(params)
  },
)

export const DeletePaymentMethodAsync = createAsyncThunk<any, any>(
  'composer/delete/paymentMethod',
  async (params) => {
    return await delete_paymentMethod(params)
  },
)
